import { ApiService, ApiServiceInterface } from "../../../../../core";
import { HomeDataResponse, HomePageController } from "../../core";

export class HomePageControllerImpl implements HomePageController {
    private api: ApiServiceInterface;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }
    async onLoad(): Promise<HomeDataResponse> {
        try {
            const response = await this.api.get('/home');
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

}